import { render, staticRenderFns } from "./AddWorkflow.vue?vue&type=template&id=872a2bbe"
import script from "./AddWorkflow.vue?vue&type=script&lang=js"
export * from "./AddWorkflow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports